import React from 'react';
import { Link } from 'react-router-dom';
import { PlugIcon } from 'lucide-react';
import { MobileLayout } from '../components/MobileLayout';
import { LastCleaningWidget } from '../components/LastCleaningWidget';
import { SuggerimentiSection } from '../components/SuggerimentiSection';
import { SharingOpportunitiesWidget } from '../components/SharingOpportunitiesWidget';
import { AIFeed } from '../components/AIFeed';
const connectorLogos = ['https://cdn.magicpatterns.com/uploads/8o1ubfwMgTbZkRjgxSm7Ki/2014_July2X.webp', 'https://cdn.magicpatterns.com/uploads/nXxoHzcUhi3uV72mH1vS3M/Booking.com_Icon_2022.svg', 'https://cdn.magicpatterns.com/uploads/hV3FRsNNz4pcm6epCwbFvK/unnamed.png'];
export function DashboardPage() {
  return <MobileLayout data-id="element-2531">
      {/* Header */}
      <div className="flex items-center justify-between mb-6" data-id="element-2532">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-2533">
          Ciao Massimo 👋
        </h1>

        {/* Connettori button */}
        <Link to="/impostazioni" className="flex items-center gap-2.5 px-3 py-2 bg-white border border-border rounded-xl hover:bg-muted transition-colors" data-id="element-2534">
          <div className="flex items-center -space-x-2" data-id="element-2535">
            {connectorLogos.map((logo, i) => <div key={i} className="w-8 h-8 rounded-full overflow-hidden shadow-sm ring-2 ring-white" data-id="element-2536">
                <img src={logo} alt="" className="w-full h-full object-cover" data-id="element-2537" />
              </div>)}
          </div>
          <span className="text-xs font-semibold text-foreground leading-tight" data-id="element-2538">
            Connettori
            <span className="block text-[10px] font-medium text-muted-foreground" data-id="element-2539">
              3 attivi
            </span>
          </span>
        </Link>
      </div>

      {/* Ultima Pulizia Widget */}
      <LastCleaningWidget data-id="element-2540" />

      {/* Suggerimenti e opportunità */}
      <SuggerimentiSection data-id="element-2541" />

      {/* Condivisione pulizie — risparmia unendoti agli host in zona */}
      <div className="mt-6" data-id="element-2542">
        <SharingOpportunitiesWidget maxItems={3} data-id="element-2543" />
      </div>

      {/* AI Smart Feed */}
      <AIFeed data-id="element-2544" />
    </MobileLayout>;
}